import { put, select, takeEvery } from "redux-saga/effects";
import { getSearchResult, getWebSitesData } from "../selectors/Selectors";
import * as Action from "../actions/Actions";
import { DISPATCHES } from "../../InterfacesTypes/enums";
import type {
  ISearchResult,
  IWebSites,
} from "../../InterfacesTypes/interfaces";
import type { PayloadAction } from "@reduxjs/toolkit";

function* searchResults(action?: PayloadAction<string>) {
  if (!action) return;

  const searchResults: ISearchResult[] = yield select(getSearchResult);

  interface KeyWordWebDataItem {
    KeyWord: string;
    WebSiteURLIndex: string;
  }

  const keyWordWebDataItemList: KeyWordWebDataItem[] = Array(0);

  searchResults.forEach((item) => {
    if (item.KeyWords) {
      const keyWords: string[] = item.KeyWords.split(";");
      keyWords.forEach((keyword) => {
        if (item.WebSiteURLIDIndex) {
          const WebSiteURLIDIndexes: string[] =
            item.WebSiteURLIDIndex.split(";");
          WebSiteURLIDIndexes.forEach((index) => {
            if (
              keyWordWebDataItemList.findIndex(
                (k) => k.KeyWord === keyword && k.WebSiteURLIndex === index
              ) === -1
            ) {
              keyWordWebDataItemList.push({
                KeyWord: keyword,
                WebSiteURLIndex: index,
              });
            }
          });
        }
      });
    }
  });

  const WebSitesData: IWebSites[] = yield select(getWebSitesData);

  // tempSearchString holds the user input
  // in form of the action payload
  const tempSearchString = action.payload;

  const keyWordResults = keyWordWebDataItemList.filter(
    (item) => item.KeyWord.toLowerCase() === tempSearchString.toLowerCase()
  );

  // Loops through keyWordResults
  // Separates indexes (by ;) into new keWordIndexes string array
  const webSiteSearchResults: IWebSites[] = [];

  keyWordResults.forEach((keyWordItem) => {
    const webSite = WebSitesData.find(
      (item) =>
        item.WebSiteURLIDIndex.toString() === keyWordItem.WebSiteURLIndex
    );
    if (webSite) {
      if (
        webSiteSearchResults.findIndex(
          (m) => m.WebSiteURLIDIndex === webSite.WebSiteURLIDIndex
        ) === -1
      ) {
        webSiteSearchResults.push(webSite);
      }
    }
  });

  yield put(Action.setMatchingWebSitesArray(webSiteSearchResults));
}

export function* searchResultsSaga() {
  yield takeEvery(DISPATCHES.SEARCH_RESULT_SAGA, searchResults);
}
